import { useState, useCallback } from 'react'
import { supabase } from '../api/supabase'

export function useJobRef() {
  const [loading, setLoading] = useState(false)

  /**
   * Z36: the next job ref comes from the ONE numbering function in the database
   * (preview_next_job_ref: current-year band, skips active reservations and burned numbers) --
   * the same one AutoJobs, Copy and Pre-reserve use. It used to be a browser-side "highest
   * job_ref string + 1" that ignored reservations and ran in a different number band.
   * It is a pure read: the number is only taken when the job row is inserted.
   */
  const generateJobRef = useCallback(async (direction: 'IMP' | 'EXP'): Promise<string> => {
    setLoading(true)
    try {
      const { data, error } = await supabase.rpc('preview_next_job_ref', { p_direction: direction })
      if (error || !data) throw new Error(error?.message || 'Could not get the next job reference')
      return data as string
    } finally {
      setLoading(false)
    }
  }, [])

  return { generateJobRef, loading }
}
